import axios from "axios";
import { configUrl } from "../../config";

export const getPredictedColleges = async (predictorType, rank, branch, category, city, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/predictor/${predictorType}/predict-colleges`, {
            rank: rank,
            branches: branch?.length > 0 ? branch : ["All"],
            category: category || "All",
            category_gender_filter: typeValue === "General" ? "general" : typeValue === "Ladies" ? "ladies" : "All",
            category_region_filter: quotaValue || "All",
            cities: city?.length > 0 ? city : ["All"],
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching AI-predicted colleges:", error);
        throw error;
    }
};

export const getPredictorFilters = async (exam) => {

    try {

        const response = await axios.get(
            `${configUrl.PredictorServer}/filters/${exam}`
        );

        return response.data;

    } catch (error) {

        console.error("Error fetching filters", error);

        return null;
    }
};